// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../graphql/api/index';

export const BlockAnchorFragmentDoc = `
    fragment blockAnchor on BlockAnchor {
  __typename
  title
  slug
}
    `;